import {FC} from 'react'
import {Routes, Route} from 'react-router-dom'
import EditOrderPage from './edit'
import RefundOrderPage from './refund'

const OrderEditPage: FC = () => {
  return (
    <Routes>
      <Route path='edit' index element={<EditOrderPage />} />
      <Route path='refund/:fulfillmentId' element={<RefundOrderPage />} />
    </Routes>
  )
}

export default OrderEditPage
